import { Avatar } from '@creditornot/cb-avatar';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import { Typography as T } from '@creditornot/cb-ingredients';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { localize } from 'common/utils';

const Root = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const LabelsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledAvatar = styled(Avatar)`
  height: 28px;
  width: 28px;
`;

const VenueName = styled(T.Body3)`
  color: ${cbSemanticCssVars.textPrimary};
`;

const VenueAddress = styled(T.Tiny)`
  color: ${({ theme }) => (theme.cbThemeMode === 'light' ? colors.pepper64 : colors.salt72)};
`;

type VenueColumnProps = {
  name: Localized;
  address: string;
  listImage: string;
};

const VenueNameColumn: FC<VenueColumnProps> = ({ name, address, listImage }) => {
  const intl = useIntl();
  return (
    <Root>
      <StyledAvatar size="small" imgSrc={listImage} />
      <LabelsContainer>
        <VenueName>{localize(name, intl.locale)}</VenueName>
        <VenueAddress>{address}</VenueAddress>
      </LabelsContainer>
    </Root>
  );
};

export default VenueNameColumn;
